import React from "react";
import Head from "next/head";
import { useGetKasadaConfigurationQuery } from "../../generated/graphql";

type KasadaProps = {
  host: string;
};

export const Kasada: React.FC<KasadaProps> = ({ host }) => {
  /** Kasada query needs to pass current host name to GraphQL to get right configuration */
  const cleanedHost = host ? host.split(":")[0] : "";
  const { data, error } = useGetKasadaConfigurationQuery({
    variables: { domain: cleanedHost },
  });

  const kasadaConfig = data?.securityConfiguration.kasada;

  if (!kasadaConfig?.scriptUrl || error) {
    return null;
  }

  return (
    <Head>
      <script type="application/javascript" src={kasadaConfig.scriptUrl} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
          if (typeof KPSDK !== "undefined") {
              try {
                  KPSDK.configure(${JSON.stringify(
                    kasadaConfig.protectedEndpoints
                  )});
              } catch (e) {
                  console.log(e)
              }
          }
          `,
        }}
      />
    </Head>
  );
};
